// ** Util Import
import { hexToRGBA } from '../utils/hex-to-rgba'

const GlobalStyles = (theme, settings) => {
  // ** Vars
  const { skin } = settings
  const isLight = theme.palette.mode === 'light'

  const perfectScrollbarThumbBgColor = () => {
    if (skin === 'semi-dark' && isLight) {
      return '#9AA5B4 !important'
    } else if (skin === 'semi-dark' && !isLight) {
      return '#C8CFDA !important'
    } else if (isLight) {
      return '#C8CFDA !important'
    } else {
      return '#5C6778 !important'
    }
  }

  return {
    body: {
      backgroundColor: theme.palette.background.default
    },
    'body[style^="padding-right"] .layout-navbar-and-nav-container::after': {
      content: '""',
      position: 'absolute',
      left: '100%',
      top: 0,
      height: '100%',
      backgroundColor: hexToRGBA(theme.palette.background.paper, 0.92),
      width: '30px'
    },
    '.demo-space-x > *': {
      marginTop: '1rem !important',
      marginRight: '1rem !important',
      'body[dir="rtl"] &': {
        marginRight: '0 !important',
        marginLeft: '1rem !important'
      }
    },
    '.demo-space-y > *:not(:last-of-type)': {
      marginBottom: '1rem'
    },
    '.MuiGrid-container.match-height .MuiCard-root': {
      height: '100%'
    },
    '.ps__rail-y': {
      zIndex: 1,
      right: '0 !important',
      left: 'auto !important',
      '&:hover, &:focus, &.ps--clicking': {
        backgroundColor: isLight ? '#E2E6ED !important' : '#3D4A5C !important'
      },
      '& .ps__thumb-y': {
        right: '3px !important',
        left: 'auto !important',
        backgroundColor: isLight ? '#C8CFDA !important' : '#5C6778 !important'
      },
      '.layout-vertical-nav &': {
        '& .ps__thumb-y': {
          width: 4,
          backgroundColor: perfectScrollbarThumbBgColor()
        },
        '&:hover, &:focus, &.ps--clicking': {
          backgroundColor: 'transparent !important',
          '& .ps__thumb-y': {
            width: 6
          }
        }
      }
    },
    '#nprogress': {
      pointerEvents: 'none',
      '& .bar': {
        left: 0,
        top: 0,
        height: 3,
        width: '100%',
        zIndex: 2000,
        position: 'fixed',
        backgroundColor: theme.palette.primary.main
      }
    }
  }
}

export default GlobalStyles
